import { View } from 'react-native'
import { styled } from '~/core/styled'

export const Root = styled(View, theme => {
  return {
    base: {
      position: 'relative',
      flex: 1,
      flexDirection: 'column',
      minWidth: 156,
      maxWidth: 360,
      padding: theme.paddingInsetThreepulse,
      borderWidth: theme.borderWidthQuarterpulse,
      borderRadius: theme.borderRadiusMediumcontainer,
      backgroundColor: theme.colorContainerFillDefault,
      borderColor: theme.colorContainerBorderDefault,
      gap: theme.paddingInsetTwopulse,
    },
  }
})
